import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {isEmpty} from '../../utils/string.utils';

function PartnerLogoLink({partnerLogo, handleClick, triggerPartnerEvent}) {
    const {image, link, text} = partnerLogo;
    return (
        <a className="site-header-logo__link has-partner-divider hidden-xxs" href={link} title={text} onClick={handleClick} onLoad={triggerPartnerEvent}>
            <img alt="partner logo" className="site-header-logo__img affiliates-logo img-responsive" src={image} />
        </a>
    );
}

PartnerLogoLink.propTypes = {
    partnerLogo: PropTypes.shape({
        image: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    }).isRequired,
    handleClick: PropTypes.func,
    triggerPartnerEvent: PropTypes.func
};

function PartnershipByline({partnerLogo}) {
    const defaultPartnershipText = 'in partnership with';

    let {partnershipText} = partnerLogo;

    if (isEmpty(partnershipText)) {
        partnershipText = defaultPartnershipText;
    }

    const classNameHidden = classNames(
        'partnership-text',
        'hidden-sm',
        'hidden-xs'
    );

    const classNameVisible = classNames(
        'logo-divider',
        'visible-sm',
        'visible-xs'
    );

    return (
        <div className="logo-separator hidden-xxs">
            <div className={classNameHidden}> {partnershipText} </div>
            <div className={classNameVisible} />
        </div>
    );
}

PartnershipByline.propTypes = {
    partnerLogo: PropTypes.shape({
        partnershipText: PropTypes.string,
    }).isRequired
};

export {PartnerLogoLink, PartnershipByline};